import { defineStore } from 'pinia'

type Issue474AbTestResult = {
  isAPattern: boolean
  isBPattern: boolean
}

export const useIssue474AbTestStore = defineStore('ab_test_issue_474', () => {
  const abTestResult = ref<Issue474AbTestResult | null>(null)

  return {
    abTestResult
  }
})
